type StorageKind = 'localStorage' | 'sessionStorage';

function getStorage(kind: StorageKind): Storage | null {
  try {
    const storage = window[kind];
    return storage ?? null;
  } catch {
    return null;
  }
}

function trySet(kind: StorageKind, key: string, value: string): boolean {
  const storage = getStorage(kind);
  if (!storage) return false;
  try {
    storage.setItem(key, value);
    return true;
  } catch {
    return false;
  }
}

function tryGet(kind: StorageKind, key: string): string | null {
  const storage = getStorage(kind);
  if (!storage) return null;
  try {
    return storage.getItem(key);
  } catch {
    return null;
  }
}

function tryRemove(kind: StorageKind, key: string): boolean {
  const storage = getStorage(kind);
  if (!storage) return false;
  try {
    storage.removeItem(key);
    return true;
  } catch {
    return false;
  }
}

export interface SafeStorage {
  setItem(key: string, value: string): boolean;
  getItem(key: string): string | null;
  removeItem(key: string): boolean;
}

export const safeLocalStorage: SafeStorage = {
  setItem: (key, value) => trySet('localStorage', key, value),
  getItem: (key) => tryGet('localStorage', key),
  removeItem: (key) => tryRemove('localStorage', key),
};

export const safeSessionStorage: SafeStorage = {
  setItem: (key, value) => trySet('sessionStorage', key, value),
  getItem: (key) => tryGet('sessionStorage', key),
  removeItem: (key) => tryRemove('sessionStorage', key),
};
